import { ReactElement } from 'react';

import { TherapeuticGroupOccupancy } from '@dreryk/egabinet-group-session-frontend-api';

import { BindingCreator, useTranslate } from '@dreryk/react-common';
import { FilterPanel, Select } from '@dreryk/react-components';

import {
   GroupSessionsFilterPanelFormBean,
   GroupSessionsFilterPanelSearchParam,
   GroupSessionsFilterPanelStorageKey,
} from '../../GroupSessionsFilterPanel.types';
import { translationKeys } from '../../../translations';
import { OCCUPANCIES } from '../../GroupSessionsFilterPanel.constants';

import {
   createOccupancyTriggerLabelExtractor,
   occupancyCodec,
   occupancyDeselectorsPropsMapper,
} from './OccupancyController.utils';
import { StyledOccupancySelect } from './OccupancySelect.styled';

type OccupancyControllerProps = {
   registerController: BindingCreator<GroupSessionsFilterPanelFormBean, 'occupancy'>;
};

export const OccupancyController = (props: OccupancyControllerProps): ReactElement => {
   const translate = useTranslate();
   return (
      <FilterPanel.Controller<GroupSessionsFilterPanelFormBean, 'occupancy'>
         name={'occupancy'}
         searchParam={GroupSessionsFilterPanelSearchParam.OCCUPANCY}
         storageKey={GroupSessionsFilterPanelStorageKey.OCCUPANCY}
         codec={occupancyCodec}
         chipsLabel={translationKeys.groupOccupancy}
         getDeselectorsProps={occupancyDeselectorsPropsMapper}
      >
         {({ applyFilter }) => (
            <StyledOccupancySelect<TherapeuticGroupOccupancy>
               testId={'occupancy'}
               triggerLabelExtractor={createOccupancyTriggerLabelExtractor(translate)}
               controller={props.registerController('occupancy')}
               onHide={applyFilter}
               label={translationKeys.groupOccupancy}
               placeholder={translationKeys.chooseOccupancy}
               compact
            >
               <>
                  <Select.List<TherapeuticGroupOccupancy> items={OCCUPANCIES}>
                     {(item) => <Select.Item item={item} label={translationKeys.occupancyMap[item]} testId={item} />}
                  </Select.List>
               </>
            </StyledOccupancySelect>
         )}
      </FilterPanel.Controller>
   );
};
